import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth/AppAuthContext";
import { Roles } from "../../firestore/Types/PermissionSchema";

export function VerifyAdmin() {
    const { userLoggedIn, permission } = useAuth();
    return (
        <>
            {!userLoggedIn && (<Navigate to={'/login'} replace={true} />)}
            {permission.Role !== Roles.Admin && (<Navigate to={'/account'} replace={true} />)}
        </>
    );
}